// extracted by mini-css-extract-plugin
export var content = "_aq-3";
export var list = "_aq-4";
export var settingsContent = "_aq-7";
export var settingsPanel = "_aq-8";
export var state = "_aq-6";
export var triggerBadge = "_aq-2";
export var triggerButton = "_aq-1";
export var triggerShell = "_aq-0";
export var unreadDot = "_aq-5";